module.exports = __webpack_public_path__ + "img/symbol-defs.7130bdb5.svg";